import { Pipe, PipeTransform } from '@angular/core';
import {ColorConverter} from "../../core/util/color-converter";


@Pipe({
    name: 'ralToHex'
})
export class RalToHexPipe implements PipeTransform {
    transform(value: string, palette: 'RAL' | 'Anodized' = 'RAL'): string {
        if (!value) {
            return '';
        }
        const colorInfo = ColorConverter.convert(value, palette);
        return colorInfo ? colorInfo.HEX : '';
    }
}
